module.exports = __webpack_public_path__ + "img/大促ing.7c4f6156.png";